// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"vaCBe","tooltipTrigger":"_2njeI"};